var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-shell"},[_vm._t("default"),_vm._t("technical-information"),_vm._t("extras"),_vm._t("filter-matches"),_vm._t("filter-selected")],2)}
var staticRenderFns = []

export { render, staticRenderFns }